import {
  APPLICANT_ACTION_ARCHIVE,
  APPLICANT_ACTION_ARCHIVE_MASS,
} from '../../RentalPortalApplicants.constants'

export const APPLICANT_SINGLE_ACTION_BY_MASS_ACTION = {
  [APPLICANT_ACTION_ARCHIVE_MASS]: APPLICANT_ACTION_ARCHIVE,
}
